"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toast = exports.default = void 0;
var _interface = require("./interface.js");
var _eventManager = require("./helpers/eventManager.js");
const toast = (type = _interface.ToastTypeEnum.success, content) => {
  _eventManager.eventManager.emit(_eventManager.Event.Show, {
    type: type,
    content: content
  });
};
exports.toast = toast;
var _default = exports.default = toast;